// AUPRÉA — Étapes 29-30 : éléments partagés des partenaires
import { C } from "./shared";
import { API } from "./integrationShared";

export const STATUT_COULEUR = { Prospect: [C.bluelt, C.blue], "Convention envoyée": [C.amberlt, C.amber], Actif: [C.greenlt, C.green], Suspendu: [C.redlt, C.red], "Ancien partenaire": ["#eee", C.mid] };

export const Pastille = ({ t, testid }) => {
  const [bg, fg] = STATUT_COULEUR[t] || [C.navylt, C.navy2];
  return <span data-testid={testid} style={{ background: bg, color: fg, borderRadius: 999, padding: "2px 10px", fontSize: 11, fontWeight: 600, whiteSpace: "nowrap" }}>{t}</span>;
};

export const Carte = ({ children, style, ...rest }) => <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 16, ...style }} {...rest}>{children}</div>;

export const Logo = ({ p, size = 44 }) => p.logo
  ? <img src={`${API}/public/partenaires/${p.id}/logo`} alt={p.nom} style={{ width: size, height: size, objectFit: "contain", borderRadius: 10, background: "#fff", border: `.5px solid ${C.border}` }} />
  : <div style={{ width: size, height: size, borderRadius: 10, background: C.navylt, color: C.navy2, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: size / 2.6 }}>{(p.nom || "?").slice(0, 2).toUpperCase()}</div>;

export const nomPartenaire = (p) => [[p.prenom, p.nom].filter(Boolean).join(" "), p.raison_sociale].filter(Boolean).join(" · ");

export const Chips = ({ items, color = C.navy2, bg = C.navylt }) => (
  <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{(items || []).map(x => <span key={x} style={{ background: bg, color, borderRadius: 999, padding: "1px 8px", fontSize: 11 }}>{x}</span>)}</div>
);

export const Frise = ({ etapes }) => (
  <div data-testid="partenaire-frise" style={{ display: "flex", gap: 0, alignItems: "center", flexWrap: "wrap", margin: "6px 0 14px" }}>
    {etapes.map((e, i) => (
      <div key={e.etape} style={{ display: "flex", alignItems: "center" }}>
        <div data-testid={`frise-${i}`} data-ok={e.ok ? "1" : "0"} style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 10px", borderRadius: 999, fontSize: 12, fontWeight: 600, background: e.ok ? C.teallt : "#fff", color: e.ok ? C.tealdm : C.muted, border: `1px solid ${e.ok ? C.teal : C.border}` }}>
          <span>{e.ok ? "✓" : i + 1}</span>{e.etape}
        </div>
        {i < etapes.length - 1 && <div style={{ width: 18, height: 2, background: etapes[i + 1].ok ? C.teal : C.border }} />}
      </div>
    ))}
  </div>
);
